import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface SiteLayoutProps {
  children: ReactNode;
  /** When true, the page renders its own full-bleed hero underneath the navbar */
  transparentNav?: boolean;
}

export default function SiteLayout({ children, transparentNav = false }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 w-full ${transparentNav ? '' : 'pt-16 md:pt-20'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}